import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-managemembers',
  templateUrl: './managemembers.component.html',
  styleUrls: ['./managemembers.component.scss']
})
export class ManageMembersComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
